const NewsroomIcon = ({ width = 16, height = 16, fill = "#374151" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_newsroom)">
      <path
        d="M13 1.26336C13 1.03655 12.725 0.923142 12.5688 1.0901L11.825 1.88395C10.5156 3.27319 8.83438 4.23085 7 4.64353V10.2194C8.83438 10.6321 10.5156 11.5866 11.825 12.979L12.5688 13.7697C12.725 13.9366 13 13.8232 13 13.5964V1.26336ZM6 10.0493V4.81364C5.81875 4.83569 5.6375 4.84829 5.45313 4.86089L4.52812 4.9113H4.51562H4.5H2C1.44687 4.9113 1 5.36177 1 5.91936V8.94355C1 9.50114 1.44687 9.95162 2 9.95162H4.5H4.5125H4.525L5.45313 10.002C5.63438 10.0115 5.81875 10.0272 6 10.0493ZM11.8438 0.397058C12.6219 -0.431445 14 0.122991 14 1.26336V13.5995C14 14.7399 12.6188 15.2944 11.8438 14.4659L11.1 13.6752C9.74688 12.2355 7.94375 11.3157 6.00313 11.0668V14.2359C6.00313 15.2093 5.21875 16 4.25313 16H3.75C2.78438 16 2 15.2093 2 14.2359V10.9597C0.896875 10.9597 0 10.0556 0 8.94355V5.91936C0 4.80734 0.896875 3.90323 2 3.90323H4.4875L5.4 3.85283C7.56875 3.72997 9.60625 2.77861 11.1 1.19091L11.8438 0.397058ZM3 10.9597V14.2359C3 14.6549 3.33438 14.9919 3.75 14.9919H4.25C4.66563 14.9919 5 14.6549 5 14.2359V10.988L4.4875 10.9597H3ZM15.5 5.91936C15.775 5.91936 16 6.14617 16 6.42339V8.43952C16 8.71674 15.775 8.94355 15.5 8.94355C15.225 8.94355 15 8.71674 15 8.43952V6.42339C15 6.14617 15.225 5.91936 15.5 5.91936Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_newsroom">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default NewsroomIcon;
